import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Filter from "./Filter";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import styles from "./JobList.module.css";
import { SearchInput } from "../../components/SearchInput";
import imgLogo from "../../assets/ACES INFOTECH PVT LIMITED.jpg";

const JobList = () => {
  const jobListings = [
    {
      title: "IT Marketing Executive",
      company: "ACES INFOTECH PVT LIMITED",
      location: "Kolkata, West Bengal",
      salary: "₹25,000 - ₹30,000 a month",
      jobType: "Full-time",
      urgency: "Urgently Hiring",
      responseTime: "Typically responds within 1 day",
      description:
        "ACES Infotech Private Limited, an ISO 9001:2015 and 14001:2015 certified organization of National repute and Pan-Indian presence...",
    },
    {
      title: "Frontend Developer",
      company: "Tech Solutions Ltd.",
      location: "Mumbai, Maharashtra",
      salary: "₹30,000 - ₹40,000 a month",
      jobType: "Full-time",
      urgency: "Hiring Now",
      responseTime: "Typically responds within 2 days",
      description:
        "We are looking for an experienced Frontend Developer to work on exciting projects with a great team.",
    },
    {
      title: "Backend Developer",
      company: "CodeMasters Pvt. Ltd.",
      location: "Bengaluru, Karnataka",
      salary: "₹40,000 - ₹50,000 a month",
      jobType: "Full-time",
      urgency: "Urgently Hiring",
      responseTime: "Typically responds within 1 day",
      description:
        "Join our growing team of engineers. We are looking for talented backend developers with strong knowledge of server-side technologies.",
    },
    {
      title: "UX/UI Designer",
      company: "DesignPro Ltd.",
      location: "Delhi, India",
      salary: "₹25,000 - ₹35,000 a month",
      jobType: "Full-time",
      urgency: "Hiring Now",
      responseTime: "Typically responds within 3 days",
      description:
        "We are looking for a creative and skilled UX/UI Designer to help improve user experiences across our web and mobile applications.",
    },
  ];

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const [openJobType, setOpenJobType] = useState(false);
  const [openSalary, setOpenSalary] = useState(false);
  const [openLocation, setOpenLocation] = useState(false);
  const [openUrgency, setOpenUrgency] = useState(false);

  const [selectedJobType, setSelectedJobType] = useState(null);
  const [selectedSalary, setSelectedSalary] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [selectedUrgency, setSelectedUrgency] = useState(null);

  const handleDialogClose = () => {
    setOpenJobType(false);
    setOpenSalary(false);
    setOpenLocation(false);
    setOpenUrgency(false);
  };

  const handleFilterSelect = (filterType, value) => {
    if (filterType === "jobType") setSelectedJobType(value);
    if (filterType === "salary") setSelectedSalary(value);
    if (filterType === "location") setSelectedLocation(value);
    if (filterType === "urgency") setSelectedUrgency(value);
    handleDialogClose();
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <Container fluid>
      {/* search bar code */}

      <Row className="justify-content-center mt-3">
        <Col xs={8} md={6} lg={3} className="p-0 me-2 rounded-0 mb-2 mb-lg-0">
          <SearchInput
            type="text"
            placeholder="Jobs title, Keywords or companies"
          />
        </Col>

        <Col xs={8} md={6} lg={3} className="p-0 me-2 rounded-0 mb-2 mb-lg-0">
          <SearchInput
            type="text"
            placeholder="City, state, Zipcode or remote"
          />
        </Col>

        <Col xs={8} md={6} lg={2} className="p-0 rounded-0 mb-2 mb-lg-0">
          <Button type="submit" className={`${styles.searchButton}`}>
            Find Jobs
          </Button>
        </Col>
      </Row>

      <div className="text-center sub_heading_title mt-3 ">Job Listings</div>
      <Row className="">
      {isMobile && (
        <Row className="g-2">
          <Col xs={6} sm={3} md={3}>
            <select
              className="form-select"
              value={selectedSalary}
              onChange={(e) => setSelectedSalary(e.target.value)}
            >
              <option>Salary</option>
              <option value="₹20,000 - ₹30,000">₹20,000 - ₹30,000</option>
              <option value="₹30,000 - ₹40,000">₹30,000 - ₹40,000</option>
              <option value="₹40,000 - ₹50,000">₹40,000 - ₹50,000</option>
            </select>
          </Col>

          <Col xs={6} sm={3} md={3}>
            <select
              className="form-select"
              value={selectedJobType}
              onChange={(e) => setSelectedJobType(e.target.value)}
            >
              <option>Experience</option>
              <option value="1-3 years">1-3 years</option>
              <option value="3-5 years">3-5 years</option>
              <option value="5+ years">5+ years</option>
            </select>
          </Col>

          <Col xs={6} sm={3} md={3}>
            <select
              className="form-select"
              value={selectedLocation}
              onChange={(e) => setSelectedLocation(e.target.value)}
            >
              <option>Work Type</option>
              <option value="Remote">Remote</option>
              <option value="On-site">On-site</option>
              <option value="Hybrid">Hybrid</option>
            </select>
          </Col>

          <Col xs={6} sm={3} md={3}>
            <select
              className="form-select"
              value={selectedUrgency}
              onChange={(e) => setSelectedUrgency(e.target.value)}
            >
              <option>Company Type</option>
              <option value="Startup">Startup</option>
              <option value="Corporate">Corporate</option>
              <option value="Agency">Agency</option>
            </select>
          </Col>
        </Row>
      )}

        <Col xs={12} md={3} lg={2} className="">
          {!isMobile && <Filter />}
        </Col>

        <Col xs={12} md={9} className="">
          <div className="w-100">
            <div className={`${styles.grid_container_explore_job}`}>
              {jobListings.map((job, index) => (
                // <Col
                //   key={index}
                //   xl={4}
                //   lg={6}
                //   md={6}
                //   sm={6}
                //   xs={12}
                //   className="d-flex"
                // >
                //   <JobCard {...job} />
                // </Col>
                <>
                  <div className={`${styles.card_shadow} p-4`}>
                    <div className="d-flex justify-content-between align-items-center">
                      <div className={styles.title}>{job?.title}</div>
                      <img
                        src={imgLogo}
                        alt="logo"
                        style={{ width: "80px" }}
                        className=""
                      />
                    </div>
                    <div className={styles.companyName}>{job?.company}</div>
                    <div className="d-flex justify-content-start gap-2">
                      <div className={styles.jobHeading}>{"Location:"}</div>
                      <div className={styles.location}>{job?.location}</div>
                    </div>
                    <div className="d-flex justify-content-start gap-2">
                      <div className={styles.jobHeading}>{"Salary:"}</div>
                      <div className={styles.location}>{job?.salary}</div>
                    </div>
                    <div className="d-flex justify-content-start gap-2">
                      <div className={styles.jobHeading}>{"Job Type:"}</div>
                      <div className={styles.location}>{job?.jobType}</div>
                    </div>
                    <div className="d-flex justify-content-start gap-2">
                      <div className={styles.jobHeading}>{"Description:"}</div>
                    </div>
                    <div className={styles.location}>{job?.description}</div>

                    <div className="d-flex justify-content-center mt-3 ">
                      <div className="btn btn-primary mt-auto">
                        Easily Apply
                      </div>
                    </div>
                  </div>
                </>
              ))}
            </div>
          </div>
        </Col>
      </Row>

      <Dialog open={openJobType} onClose={handleDialogClose}>
        <DialogTitle>Filter by Salary</DialogTitle>
        <DialogContent>
          <Button onClick={() => handleFilterSelect("jobType", "$10k - $50k")}>
            $10k - $50k
          </Button>
          <Button onClick={() => handleFilterSelect("jobType", "$50k - $100k")}>
            $50k - $100k
          </Button>
          <Button
            onClick={() => handleFilterSelect("jobType", "$100k - $150k")}
          >
            $100k - $150k
          </Button>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose}>Close</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openSalary} onClose={handleDialogClose}>
        <DialogTitle>Filter by Experience</DialogTitle>
        <DialogContent>
          <Button onClick={() => handleFilterSelect("salary", "0-2 years")}>
            0-2 years
          </Button>
          <Button onClick={() => handleFilterSelect("salary", "3-5 years")}>
            3-5 years
          </Button>
          <Button onClick={() => handleFilterSelect("salary", "6-10 years")}>
            6-10 years
          </Button>
          <Button onClick={() => handleFilterSelect("salary", "10+ years")}>
            10+ years
          </Button>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose}>Close</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openLocation} onClose={handleDialogClose}>
        <DialogTitle>Filter by Work Mode</DialogTitle>
        <DialogContent>
          <Button onClick={() => handleFilterSelect("location", "Remote")}>
            Remote
          </Button>
          <Button onClick={() => handleFilterSelect("location", "Hybrid")}>
            Hybrid
          </Button>
          <Button onClick={() => handleFilterSelect("location", "On-site")}>
            On-site
          </Button>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose}>Close</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openUrgency} onClose={handleDialogClose}>
        <DialogTitle>Filter by Company</DialogTitle>
        <DialogContent>
          <Button onClick={() => handleFilterSelect("urgency", "Company A")}>
            Company A
          </Button>
          <Button onClick={() => handleFilterSelect("urgency", "Company B")}>
            Company B
          </Button>
          <Button onClick={() => handleFilterSelect("urgency", "Company C")}>
            Company C
          </Button>
          <Button onClick={() => handleFilterSelect("urgency", "Company D")}>
            Company D
          </Button>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default JobList;
